import { normalizeIsoCountry } from '@/lib/geo/country';
import type { Settings } from '@/types/settings';

/**
 * Resolve the `country` attribute sent to GrowthBook for targeting.
 *
 * Order of preference:
 * 1. `settings.country.iso_code_2` — the canonical ISO 3166-1 alpha-2 source
 *    on the settled session. `settings.user.country` is a display-name
 *    string ("United States") and MUST NOT be used here; doing so caused
 *    DEV-5797 (every logged-in US user mis-routed into `pricing-test-usd-row`).
 * 2. The `geo-country` cookie — populated from Vercel's edge geo header for
 *    logged-out / pre-settings paints.
 * 3. `undefined` — better than a junk value reaching GrowthBook's ISO-code
 *    targeting rules.
 *
 * Both inputs pass through `normalizeIsoCountry`, which accepts either a
 * 2-letter ISO code or an English display name. The DEV-5797 root cause
 * (reading the wrong field) is still avoided by only consulting
 * `country.iso_code_2`, not `user.country`.
 */
export function resolveGrowthBookCountry(
  settings: Settings | null | undefined,
  cookieCountry: string | null | undefined
): string | undefined {
  return (
    normalizeIsoCountry(settings?.country?.iso_code_2) ||
    normalizeIsoCountry(cookieCountry)
  );
}
